import React, { useEffect, useRef, useState } from 'react';

const VideoPostItemLg = ({ src, turn }) => {
  const video = useRef();
  const source = useRef();
  const control = useRef();
  const [start, setStart] = useState(false);

  const handleControl = () => {
    if (video.current.paused) {
      video.current.play();
    } else {
      video.current.pause();
    }

    if (video.current.paused) {
      control.current.classList.remove('hide-control');
    } else {
      control.current.classList.add('hide-control');
    }
  };

  useEffect(() => {
    if (!start) {
      control.current.addEventListener('click', handleControl);
    }

    if (turn === 0) {
      video.current.currentTime = 0;
      video.current.play();
    }

    if (!start) {
      setStart(true);
    }

    if (video.current.paused) {
      control.current.classList.remove('hide-control');
    } else {
      control.current.classList.add('hide-control');
    }
  }, []);

  return (
    <div className="media-video">
      <video className="media-video" autoPlay={false} loop={true} ref={video}>
        <source src={src} type="video/mp4" ref={source} />
      </video>
      <div className={`all-center media-control-caption`} ref={control}>
        {<span className={'videoSpritePlayButton'} />}
      </div>
    </div>
  );
};

export default VideoPostItemLg;
